// extracted by mini-css-extract-plugin
export var modalFooter = "_td-0";